import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typography, TextField, Box, CircularProgress } from '@material-ui/core';
import { PhoneInput } from '@icimscorp/mui-acs';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';

export default function AddForm({ onSubmitCallback, isAdding }) {
	const { t } = useTranslation();
	const [error, setError] = React.useState(null);
	const [names, setNames] = React.useState({
		first: { value: '', error: null },
		last: { value: '', error: null },
	});

	const classes = useStyles();

	const handleFormSubmission = (e) => {
		e.preventDefault();
		if (error || isAdding) {
			return;
		}
		const formData = new FormData(e.target);
		const firstName = formData.get('firstName');
		const lastName = formData.get('lastName');
		const phoneNumber = formData.get('phone');
		onSubmitCallback({ firstName, lastName, phoneNumber });
	};

	const handleInputChange = (e, type) => {
		setNames((prev) => ({
			...prev,
			[type]: {
				...prev[type],
				value: e.target.value.trim(),
			},
		}));
	};

	const handleErrorOnBlur = (type) => {
		const v = names[type].value.trim();
		setNames((prev) => ({
			...prev,
			[type]: {
				...prev[type],
				error: v === '' ? t('required', 'required') : null,
			},
		}));
	};

	const handlePhoneData = (data) => {
		if (data.error) {
			setError(data.error);
		}
	};

	return (
		<Box
			component="form"
			className={classes.form}
			onSubmit={handleFormSubmission}
			autoComplete="on"
			height="100%"
			display="flex"
		>
			<Typography>
				{t('ready_to_chat', 'We&#8217;re ready to chat! Can you provide us some info?')}
			</Typography>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					flexGrow: 1,
				}}
			>
				<TextField
					id="first-name"
					name="firstName"
					error={Boolean(names.first.error)}
					label={t('first_name', 'First Name')}
					onChange={(e) => handleInputChange(e, 'first')}
					onBlur={() => handleErrorOnBlur('first')}
					required
					type={'text'}
					variant="outlined"
					value={names.first.value}
					helperText={names.first.error}
				/>

				<TextField
					id="last-name"
					name="lastName"
					error={Boolean(names.last.error)}
					label={t('last_name', 'Last Name')}
					onChange={(e) => handleInputChange(e, 'last')}
					onBlur={() => handleErrorOnBlur('last')}
					required
					type={'text'}
					variant="outlined"
					value={names.last.value}
					helperText={names.last.error}
				/>

				<PhoneInput handlePhoneData={handlePhoneData} />
			</Box>
			<Button
				variant="contained"
				color="primary"
				type="submit"
				aria-disabled={Boolean(error) || isAdding}
				startIcon={isAdding && <CircularProgress color="inherit" size={24} />}
			>
				<Typography>{t('save', 'Save')}</Typography>
			</Button>
		</Box>
	);
}

AddForm.propTypes = {
	onSubmitCallback: PropTypes.func,
	isAdding: PropTypes.bool,
};
